export const postMessage = (
  id: string | number,
  certificateUrl: string,
  status: string,
  score_percent: number
) => {
  if (window && window.parent) {
    window.parent.postMessage(
      {
        id,
        certificateUrl: certificateUrl || '',
        status,
        scorePercent: score_percent
      },
      '*'
    );
  }
};
